module.exports = __webpack_public_path__ + "static/img/pic3.330e12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example01/pic3.png
// module id = Gxm0
// module chunks = 1